var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.bic.bic_code"),
                      maxLength: 11,
                    },
                    model: {
                      value: _vm.BicCode,
                      callback: function ($$v) {
                        _vm.BicCode = $$v
                      },
                      expression: "BicCode",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.bic.bic_code"),
                      inputValue: _vm.BicCode,
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }